<template>
  <div>
    <b-card class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          <div class="d-flex">รายการนัดหมาย {{ totalPage }}</div>
          <div cols="12">
            <b-form-group label="วันที่พบ (ว/ด/ป)" label-cols-md="12">
              <b-form-datepicker v-model="formMeeting" @context="updateYear" @input="selectdate()"
                :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" placeholder="วันที่พบ"
                label-today-button="วันนี้" label-reset-button="รีเซ็ต" today-button>
              </b-form-datepicker>
            </b-form-group>
          </div>
        </div>
        <div class="bd-highlight">
          <!-- <b-button
            variant="success"
            @click="
              () => {
                this.$router.push({ name: 'addMeet' });
              }
            "
          >
            เพิ่ม
          </b-button> -->
        </div>
      </b-nav>
    </b-card>
    <b-alert :show="isNodata" class="w-50 w-100" variant="danger">
      <div class="alert-body text-center">
        <feather-icon icon="InfoIcon" class="mr-50" />
        <span>ไม่มีข้อมูล</span>
      </div>
    </b-alert>
    <b-overlay :show="playLoad" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div class="row h-100">
        <div v-for="(item, index) in items" :key="index" class="col-12 col-md-4 col-lg-4">
          <b-card header-tag="header" footer-tag="footer" :border-variant="item.variant">
            <template #header>
              <div class="h4">{{ item.meetUpLocal }}</div>

              <div>

                <b-badge :variant="`light-${item.variant}`">{{ item.status }}</b-badge>
              </div>
            </template>

            <b-card-text>ชื่อสกุล Visitor: {{ item.name }} </b-card-text>
            <b-card-text>เลขทะเบียนรถ Visitor: {{ item.licensePlate }} </b-card-text>
            <b-card-text>ผู้มาขอเข้าพบ: {{ item.nameMeet }} </b-card-text>

            <template #footer>
              <div class="d-flex justify-content-between">
                <b-card-text>วันเวลาที่พบ : {{ formatToThaiTime(item.daysToCome) }} </b-card-text>
                <b-card-text v-if="item.status === 'นัด'" class="p-0 m-0">
                  <b-button @click="updateStatus(item)" variant="outline-info" size="sm" class="m-0">E-Stemp</b-button>
                </b-card-text>
                <b-card-text v-else class="p-0 m-0">
                  <b-button disabled @click="updateStatus(item)" variant="outline-secondary" size="sm"
                    class="m-0">E-Stemp</b-button>
                </b-card-text>

              </div>
            </template>

            <!-- <b-link class="card-link"> Card link </b-link>
        <b-link class="card-link"> Another link </b-link> -->
          </b-card>
        </div>
      </div>
    </b-overlay>
    <b-card v-show="false" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>Showing {{ currentPage }} to {{ perPage }} of {{ totalPage }} entries</div>
        <div class="bd-highlight">
          <!-- <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage" @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next" align="left" last-text="Last" hide-goto-end-buttons /> -->
        </div>
      </b-nav>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import API from '@/connect/config';

import dayjs from 'dayjs';
import 'dayjs/locale/th';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import BCardActionsContainer from '@/@core/components/b-card-actions/BCardActionsContainer.vue';
dayjs.extend(utc);
dayjs.extend(timezone);
const buddhistEra = require('dayjs/plugin/buddhistEra');
dayjs.extend(buddhistEra);
const relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);
export default {
  components: { BCardActionsContainer },
  data() {
    return {
      currentPage: 1, // จำนวนรายการที่แสดงในแต่ละหน้า
      perPage: 6, // จำนวนรายการที่แสดงในแต่ละหน้า
      totalPage: 0, // จำนวนรายการ
      //loading
      playLoad: false,
      isNodata: false,
      //data
      items: [],
      meetTingCount: '',
      formMeeting: dayjs().locale('th').format('YYYY-MM-DD'),
      BBBB: dayjs().locale('th').format('BBBB'),
      YYYY: dayjs().locale('th').format('YYYY'),
    };
  },
  async created() {
    this.getDataTable();
  },
  methods: {
    selectdate() {
      console.log(this.formMeeting)
      this.items = [];
      this.getDataTable();
    },

    updateYear(context) {
      let currentDate = dayjs(this.formMeeting);
      let updatedDate = currentDate.year(this.BBBB);

      // Update the date value with the new year
      this.formMeeting = updatedDate.format('YYYY-MM-DD');
    },
    updateStatus(item) {
      this.$swal({
        title: 'คุณต้องการ E-Stemp ?',
        html: `${item.meetUpLocal}<br>ชื่อสกุล Visitor : ${item.name} <br>เลขทะเบียนรถ Visitor : ${item.licensePlate}<br>ผู้มาขอเข้าพบ : ${item.nameMeet}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'E-Stemp',
        cancelButtonText: 'ปิด',
        customClass: {
          confirmButton: 'btn btn-outline-success',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {

          const { userId } = JSON.parse(localStorage.getItem('company_jwt_vis'));
          const datameeting = {
            userId: userId,
            meetingId: item.meetingId,
            status: 'นัด',
          };

          axios
            .put(`${API}meeting`, datameeting)
            .then((res) => {
              this.$swal({
                icon: 'success',
                title: 'E-Stemp เรียบร้อย.',
                html: `${item.meetUpLocal}<br>ชื่อสกุล Visitor : ${item.name} <br>เลขทะเบียนรถ Visitor : ${item.licensePlate}<br>ผู้มาขอเข้าพบ : ${item.nameMeet}`,
                confirmButtonText: 'ปิด',
                customClass: {
                  confirmButton: 'btn btn-outline-danger',
                },
              });
              this.$store.commit('setToastMessage', {
                message: res.data.message,
                title: 'E-Stemp',
                variant: 'primary',
              });
              this.items = [];
              this.getDataTable();
            })
            .catch((err) => {
              console.error('LIFF initialization failed', err);
            });
        }
      });
    },
    async getDataTable() {
      this.playLoad = true;
      const { userId } = JSON.parse(localStorage.getItem('company_jwt_vis'));
      let uId = JSON.parse(localStorage.getItem('profile_visitor')).userId;
      const url = `${API}meeting/${userId}?uId=${uId}`;
      this.$store
        .dispatch('getAll', url)
        .then((res) => {
          let i = 0;
          res.map((el) => {
            console.log(el)
            if (uId == el.uId) {
              if (el.status == 'นัด') {
                el['variant'] = 'warning';
              } else if (el.status == 'มา') {
                el['variant'] = 'success';
              } else if (el.status == 'ยกเลิก') {
                el['variant'] = 'danger';
              }
              this.items.push(el);
              this.meetTingCount = i++;
            }
          });
          let currentDate = dayjs(this.formMeeting);
          let updatedDate = currentDate.year(this.YYYY);

          const filteredVisitors = this.items.filter(visitor => {
            const visitorDate = dayjs(visitor.daysToCome, 'BBBB-MM-DD');
            return visitorDate.isSame(updatedDate, 'day');
          });

          this.items.sort(function (a, b) {
            if (a.registerDate < b.registerDate) return 1;
            else if (a.registerDate > b.registerDate) return -1;
            else return 0;
          });
          this.items = filteredVisitors
          this.totalPage = this.items.length;
          this.isNodata = this.items.length == 0 ? true : false;
          this.playLoad = false;
        })
        .catch((err) => {
          console.error('LIFF initialization failed', err);
        });
    },
    showmore() {
      this.currentPage += 1;
      this.getDataTable();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.items = [];
      this.getDataTable();
    },
    handleItemsPerPageChange() {
      // กรณีที่ต้องการให้เลือกจำนวนรายการที่แสดงเปลี่ยนแปลงทันที
      this.currentPage = 1;
      this.items = [];
      this.getDataTable();
    },

    formatToThaiTime(_date) {
      let date = new Date(_date);
      // เปลี่ยนวันที่ไทย
      return dayjs.tz(date, 'Asia/Bangkok').locale('th').format('DD MMM BBBB HH:mm');
    },
  },
};
</script>

<style></style>
